import { PedaGaugeProps, PedagogyUtils } from "@kalyzee/escaet-ui";
import { MeetingOrderedSession } from "@kalyzee/kast-web-sdk";
import { MeetingSession } from "@kalyzee/kast-web-sdk/websocket";
import { useReducedAlerts } from "../../hooks/meeting";
import { AlertsThresholds, getNonAlertsScore } from "../../helpers/alerts";

export interface BadBehaviorsCounterProps {
  sessions?: (MeetingSession | MeetingOrderedSession)[];
  style?: React.CSSProperties;
  gaugeStyle?: React.CSSProperties;
  getColor?: PedaGaugeProps["getColor"];
}

export const BadBehaviorsCounter: React.FC<BadBehaviorsCounterProps> = ({
  sessions,
  style,
  gaugeStyle,
  getColor,
}) => {
  const alerts = useReducedAlerts(sessions);
  // Adding 1 so min value in the gauge is 1
  return (
    <div style={{
      display: "flex",
      flexDirection: "row",
      gap: "0.5em",
      height: 50,
      alignItems: "center",
      ...(style || {}),
    }}>
      <PedagogyUtils.BadBehaviorsGauges.NoCamera 
        style={gaugeStyle}
        value={getNonAlertsScore(alerts.camera, alerts.users) + 1}
        capacity={AlertsThresholds.length + 1}
        text={`${alerts.camera}`}
        getColor={getColor}
      />
      <PedagogyUtils.BadBehaviorsGauges.NotAttentive 
        style={gaugeStyle}
        value={getNonAlertsScore(alerts.attention, alerts.users) + 1}
        capacity={AlertsThresholds.length + 1}
        text={`${alerts.attention}`}
        getColor={getColor}
      />
    </div>
  );
};